// extracted by mini-css-extract-plugin
export var productImage = "_os-1";
export var viewLink = "_os-2";
export var wishlistItem = "_os-0";